<template>
    <div :class="`col-sm-6`">
        <div class="form-group">
            <button type="button" class="daum-btn btn btn-primary btn-xs w-100" :data-form="`#dwfrm_${__vue_currentForm}`"
                v-html="$t('button.findpostalcode')"> </button>
        </div>
    </div>
</template>

<script setup>
import { mapGetters } from "@/store/helper/vuex";
import { computed } from 'vue'
const { currentStage } = mapGetters();

const __vue_currentForm = computed(() => { 
    return currentStage && !window.vueCurrentActiveStates['sor'] ? (currentStage.value === 'shipping' ? 'shipping' : 'billing') : 'internationalAddress' 
});
</script>